import { render } from "./command-history.vue?vue&type=template&id=7dc9c8fd&scoped=true"
import script from "./command-history.vue?vue&type=script&lang=js"
export * from "./command-history.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7dc9c8fd"

export default script